/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiScamExportExportStatusJobId200,
  PostApiScamExportExport200,
  ScamExportBodyApiDTO,
  ScamExportRowApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const postApiScamExportPreview = (
    scamExportBodyApiDTO: ScamExportBodyApiDTO,
 ) => {
      
      
      return customInstance<ScamExportRowApiDTO[]>(
      {url: `/api/scam-export/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scamExportBodyApiDTO
    },
      );
    }
  


export const getPostApiScamExportPreviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportPreview>>, TError,{data: ScamExportBodyApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportPreview>>, TError,{data: ScamExportBodyApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiScamExportPreview>>, {data: ScamExportBodyApiDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiScamExportPreview(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiScamExportPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof postApiScamExportPreview>>>
    export type PostApiScamExportPreviewMutationBody = ScamExportBodyApiDTO
    export type PostApiScamExportPreviewMutationError = ErrorType<unknown>

    export const usePostApiScamExportPreview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportPreview>>, TError,{data: ScamExportBodyApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiScamExportPreview>>,
        TError,
        {data: ScamExportBodyApiDTO},
        TContext
      > => {

      const mutationOptions = getPostApiScamExportPreviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiScamExportExport = (
    scamExportBodyApiDTO: ScamExportBodyApiDTO,
 ) => {
      
      
      return customInstance<PostApiScamExportExport200>(
      {url: `/api/scam-export/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scamExportBodyApiDTO
    },
      );
    }
  


export const getPostApiScamExportExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportExport>>, TError,{data: ScamExportBodyApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportExport>>, TError,{data: ScamExportBodyApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiScamExportExport>>, {data: ScamExportBodyApiDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiScamExportExport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiScamExportExportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiScamExportExport>>>
    export type PostApiScamExportExportMutationBody = ScamExportBodyApiDTO
    export type PostApiScamExportExportMutationError = ErrorType<unknown>

    export const usePostApiScamExportExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiScamExportExport>>, TError,{data: ScamExportBodyApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiScamExportExport>>,
        TError,
        {data: ScamExportBodyApiDTO},
        TContext
      > => {

      const mutationOptions = getPostApiScamExportExportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiScamExportExportStatusJobId = (
    jobId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiScamExportExportStatusJobId200>(
      {url: `/api/scam-export/export/status/${jobId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiScamExportExportStatusJobIdQueryKey = (jobId: string,) => {
    return [`/api/scam-export/export/status/${jobId}`] as const;
    }

    
export const getGetApiScamExportExportStatusJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiScamExportExportStatusJobIdQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>> = ({ signal }) => getApiScamExportExportStatusJobId(jobId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiScamExportExportStatusJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>>
export type GetApiScamExportExportStatusJobIdQueryError = ErrorType<unknown>

export const useGetApiScamExportExportStatusJobId = <TData = Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiScamExportExportStatusJobId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiScamExportExportStatusJobIdQueryOptions(jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



